import React from 'react';
import { UiKit } from '@datavant/uikit';
import { VStack } from '@chakra-ui/react';
import { trpc } from '../../../../utils/trpc';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { openSCConnector } from '../helpers';

export const DVConnectorModal = (props: { onClose: () => void; isOpen: boolean }) => {
    const { data: tenant } = trpc.tenant.getTenant.useQuery(undefined, {
        staleTime: Infinity, // ✅ Data is always considered fresh
        cacheTime: Infinity, // ✅ Cache never garbage-collected
        refetchOnMount: false, // 🚫 Don't re-fetch on component remount
        refetchOnWindowFocus: false, // 🚫 Don't re-fetch when switching tabs
        refetchOnReconnect: false, // 🚫 Don't re-fetch when network reconnects
    });

    const onClick = () => {
        if (
            tenant?.digitalMetadata?.emr === null ||
            tenant?.digitalMetadata?.emr === undefined ||
            tenant?.digitalMetadata?.onboardingStatus === null ||
            tenant?.digitalMetadata?.onboardingStatus === undefined
        ) {
            return;
        }

        openSCConnector({
            emr: tenant?.digitalMetadata?.emr,
            onboardingStatus: tenant?.digitalMetadata?.onboardingStatus,
            addressFeedbackComplete: tenant?.digitalMetadata?.addressFeedbackComplete,
            digitalSiteId: tenant?.digitalMetadata?.digitalSiteId,
        });
    };

    const ModalBody = (
        <VStack width={'100%'} alignItems={'left'} spacing={UiKit.consistency.extraLargeBuffer}>
            <UiKit.Text.BodyRegularBold>
                To continue AutoFulfill set up, we need to connect your Electronic Medical Record (EMR)
                system. This helps ensure secure and seamless data exchange.
            </UiKit.Text.BodyRegularBold>
            <UiKit.Text.BodyRegular>
                You can request a copy of the completed agreements from requestmanager@datavant.com for your
                records.
            </UiKit.Text.BodyRegular>
        </VStack>
    );

    const ModalFooter = (
        <UiKit.Chakra.VStack>
            <UiKit.Chakra.HStack w={'full'} justifyContent={'flex-end'} spacing={UiKit.consistency.buffer}>
                <UiKit.Button.Cancel text={'Not Now'} onClick={props.onClose} />
                <UiKit.Button.Primary
                    text="Set Up EMR Connection"
                    onClick={onClick}
                    rightIcon={<FontAwesomeIcon icon={UiKit.Icons.FontAwesome.solid.faArrowRight} />}
                />
            </UiKit.Chakra.HStack>
        </UiKit.Chakra.VStack>
    );

    return (
        <UiKit.Modal
            title={'Continue to Set Up EMR Connection'}
            bodyFragment={ModalBody}
            footerFragment={ModalFooter}
            onClose={props.onClose}
            isOpen={props.isOpen}
            size={'2xl'}
            fullScreen={false}
        />
    );
};
